export const GET_CONFIG_FAILURE = 'get-config-failure';
export const NAV_RENDER_FAILURE = 'nav-render-failure';
export const NAV_RENDERED_FROM_LOCAL_STORAGE = 'nav-rendered-from-local-storage';
export const GET_HUBLESS_CONFIG_FAILURE = 'get-hubless-config-failure';
export const INACCURATE_NAV_CONFIG_RESPONSE = 'inaccurate-nav-config-response';
export const VERTICAL_NAV_LOADED = 'vertical-nav-loaded';
export const VERTICAL_NAV_RENDERED = 'vertical-nav-rendered';
export const HEADLESS_NAV_RENDERED = 'headless-nav-rendered';